import { Injector } from '@angular/core';
import { MethodError } from '@lentau/core/api/application';
import { lazyB2bMobileCheckoutErrorTracker } from '@lentau/checkout/stepper/application/services/b2b-mobile-chekcout-error-tracker/b2b-mobile-checkout-error-tracker.loader';
import { B2bMobileCheckoutErrorTrackerService } from '@lentau/checkout/stepper/application/services/b2b-mobile-chekcout-error-tracker/b2b-mobile-checkout-error-tracker.service';

export const handleMobileCheckoutB2bErrors = async (error: MethodError, injector: Injector): Promise<void> => {
  lazyB2bMobileCheckoutErrorTracker(injector)
    .then((checkoutErrorTracker: B2bMobileCheckoutErrorTrackerService) => {
      if (!!checkoutErrorTracker && checkoutErrorTracker.isActive()) {
        checkoutErrorTracker.reportHttpErrorListForAnalytics(error);
      }
    })
    .catch((err: unknown) => {
      console.error(err);
    });
};
